/**
 * docs: https://developers.google.com/recaptcha/docs/v3#actions
 */
 enum googleRecaptchaActions {
  studentData= 'student_data',
  requestSearch= 'search_request',
  newRequest= 'new_request'
}

export default googleRecaptchaActions
